export const OPEN_SELECT_DEALER_MODAL = 'DEALERS/SELECT_MODAL/OPEN';
export const CLOSE_SELECT_DEALER_MODAL = 'DEALERS/SELECT_MODAL/CLOSE';

export const GET_MODAL_DEALERS = 'DEALERS/SELECT_MODAL/REQUEST';
export const GET_MODAL_DEALERS_SUCCESS = 'DEALERS/SELECT_MODAL/SUCCESS';
export const GET_MODAL_DEALERS_FAILURE = 'DEALERS/SELECT_MODAL/FAILURE';

export const SET_MODAL_DEALERS_FILTER = 'DEALERS/SELECT_MODAL/FILTERS/SET';
export const CLEAR_MODAL_DEALERS_FILTER = 'DEALERS/SELECT_MODAL/FILTERS/CLEAR';
export const REMOVE_MODAL_DEALERS_FILTER = 'DEALERS/SELECT_MODAL/FILTERS/REMOVE';

export const FOLD_EXPENDED_SEARCH = 'DEALERS/SELECT_MODAL/FILTER/EXPENDED_SEARCH/FOLD';
export const UNFOLD_EXPENDED_SEARCH = 'DEALERS/SELECT_MODAL/FILTER/EXPENDED_SEARCH/UNFOLD';

export const LOAD_DEALER = 'DEALERS/NEW_SELECT/LOAD_DEALER';

export const SET_PAGINATED_DEALERS_FILTERS = 'DEALERS/PAGINATED_SELECT/SET_FILTERS';
export const GET_PAGINATED_DEALERS_FETCH = 'DEALERS/PAGINATED_SELECT/FETCH/REQUEST';
export const GET_PAGINATED_DEALERS_FETCH_SUCCESS = 'DEALERS/PAGINATED_SELECT/FETCH/SUCCESS';
export const GET_PAGINATED_DEALERS_FETCH_FAILURE = 'DEALERS/PAGINATED_SELECT/FETCH/FAILURE';

export const UPLOAD_USERS_DEALER = 'DEALERS/ADMIN_CONFIG/UPLOAD_USERS/REQUEST';
export const DASHBOARD_IS_READY = 'USERS/DASHBOARD/IS_READY';

export const PREDEFINED_MESSAGES_FETCH = 'DEALERS/PREDEFINED_MESSAGES/FETCH/REQUEST';
export const PREDEFINED_MESSAGES_FETCH_SUCCESS = 'DEALERS/PREDEFINED_MESSAGES/FETCH/SUCCESS';
export const PREDEFINED_MESSAGES_FETCH_FAILURE = 'DEALERS/PREDEFINED_MESSAGES/FETCH/FAILURE';

export const TRIGGER_KEYLOOP_REFRESH = 'DEALERS/KEYLOOP/TRIGGER_REFRESH/REQUEST';
